import {
  Box,
  Checkbox,
  darken,
  FormControlLabel,
  FormGroup,
  lighten,
  Popover,
  Stack,
  Switch,
  Typography,
  useTheme,
} from "@mui/material";
import useStyles from "./styles";
import { useMemo } from "react";
import { useEffect } from "react";

const ConfigLocalPopover = ({
  position,
  anchorEl,
  setAnchorEl,
  setEasyMapsConfig = () => {},
  easyMapsConfig,
  isFtth,
  config,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);

  const localStorageConfig = JSON.parse(
    localStorage.getItem("easyMapsConfig") || "{}"
  );

  const handleClose = () => {
    setAnchorEl(null);
  };

  function handleChange(event, path, name) {
    const checked = !!event?.target?.checked;

    setEasyMapsConfig((prev) => {
      const data = { ...(prev ?? {}) };
      const curr = data[path];

      // Para noDataElements
      if (name === undefined) {
        data[path] = checked;
        return data;
      }

      // Array de valores (Filtro de potência)
      if (Array.isArray(curr)) {
        const exists = curr.includes(name);
        data[path] = checked
          ? exists
            ? curr
            : [...curr, name]
          : curr.filter((x) => x !== name);
        return data;
      }

      // Objetos (Animação)
      if (curr && typeof curr === "object") {
        data[path] = { ...curr, [name]: checked };
        return data;
      }

      const isNumericName =
        typeof name === "number" ||
        (typeof name === "string" &&
          name.trim() !== "" &&
          !Number.isNaN(Number(name)));

      data[path] = isNumericName
        ? checked
          ? [name]
          : []
        : { [name]: checked };

      return data;
    });
  }

  const escalas = useMemo(() => config?.escalas?.ftth, [config?.escalas?.ftth]);

  return (
    <Popover
      id={"popoverConfig"}
      anchorReference="anchorPosition"
      anchorPosition={position}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      sx={{
        zIndex: 1501,
        "& .MuiPopover-paper": {
          backgroundColor: "transparent",
          p: "0px",
        },
      }}
      // }}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
    >
      <Stack sx={styles.container}>
        <Typography sx={styles.title}>Ajustes do Mapa</Typography>
        {!isFtth && (
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={
                  easyMapsConfig?.animacao?.alertas == null ||
                  easyMapsConfig?.animacao?.alertas == true
                    ? true
                    : false
                }
              />
            }
            sx={styles.switch}
            labelPlacement="start"
            label={
              <Typography sx={[styles.textAdorment, { ml: 0.3 }]}>
                ANIMAÇÃO DE ALERTAS
              </Typography>
            }
            onChange={(event) => handleChange(event, "animacao", "alertas")}
          />
        )}

        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={
                easyMapsConfig?.animacao?.linha == null ||
                easyMapsConfig?.animacao?.linha == true
                  ? true
                  : false
              }
            />
          }
          sx={styles.switch}
          labelPlacement="start"
          label={
            <Typography sx={[styles.textAdorment, { ml: 0.3 }]}>
              ANIMAÇÃO DE LINHAS
            </Typography>
          }
          onChange={(event) => handleChange(event, "animacao", "linha")}
        />
        {isFtth && (
          <>
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  checked={
                    easyMapsConfig?.esconderOnu == null ||
                    easyMapsConfig?.esconderOnu == true
                      ? true
                      : false
                  }
                />
              }
              sx={styles.switch}
              labelPlacement="start"
              label={
                <Typography sx={[styles.textAdorment, { ml: 0.3 }]}>
                  ESCONDER ONUs
                </Typography>
              }
              onChange={(event) => handleChange(event, "esconderOnu")}
            />
            <Stack sx={styles.switch}>
              <Typography sx={[styles.textAdorment, { ml: 0.3 }]}>
                FILTROS POR POTÊNCIA
              </Typography>
              <FormGroup
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                {escalas
                  ?.slice()
                  ?.sort((a, b) => {
                    const na = parseFloat(a.label);
                    const nb = parseFloat(b.label);
                    if (Number.isNaN(na)) return -1;
                    if (Number.isNaN(nb)) return 1;
                    return nb - na;
                  })
                  ?.map((escala, idx, arr) => {
                    const currentLabel = escala.label;
                    const nextLabel = arr[idx + 1]?.label;

                    let label;

                    if (currentLabel === "Sem Dados") {
                      label = "Sem Dados / Fora da escala";
                    } else if (nextLabel && nextLabel !== "Sem Dados") {
                      label = `${currentLabel} dBm a ${nextLabel} dBm`;
                    } else {
                      label = `${currentLabel} dBm ou mais`;
                    }

                    return (
                      <FormControlLabel
                        key={escala.label}
                        control={
                          <Checkbox
                            checked={
                              Array.isArray(easyMapsConfig?.filtroPotencia) &&
                              easyMapsConfig?.filtroPotencia.includes(
                                escala.label
                              )
                            }
                            onChange={(event) =>
                              handleChange(
                                event,
                                "filtroPotencia",
                                escala.label
                              )
                            }
                          />
                        }
                        label={
                          <Stack sx={styles.stackCheckBox}>
                            <Box
                              sx={[
                                styles.boxEscalaCheckBox,
                                {
                                  backgroundColor: escala.cor,
                                  "&:hover": {
                                    backgroundColor:
                                      theme.palette.mode === "dark"
                                        ? lighten(escala.cor, 0.5)
                                        : darken(escala.cor, 0.3),
                                  },
                                },
                              ]}
                            />
                            <Typography sx={styles.subtitle}>
                              {label}
                            </Typography>
                          </Stack>
                        }
                      />
                    );
                  })}
              </FormGroup>
            </Stack>
          </>
        )}
      </Stack>
    </Popover>
  );
};

export default ConfigLocalPopover;
